<template>
    <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide
            ><div class="banner-item">
                <div
                    class="banner-img"
                    :style="{ backgroundImage: 'url(' + imgUrl + ')' }"
                ></div>
                <div class="banner-cont">
                    <div class="text-box">
                        <p class="title">
                            Make Connection Easy<br />
                            Make Business Agile
                        </p>
                        <p class="cont">
                            {{ $t("h.ban1") }} &nbsp; {{ $t("h.ban2") }} &nbsp;
                            {{ $t("h.ban3") }}
                        </p>
                    </div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide
            ><div class="banner-item">
                <div
                    class="banner-img"
                    :style="{ backgroundImage: 'url(' + imgUrl1 + ')' }"
                ></div>
                <div class="banner-cont">
                    <div class="text-box">
                        <p class="title" style="width:760px">
                            OCEANBLUE CLOUD SD-WAN
                        </p>
                        <p class="cont">
                            Make Connection Easy&nbsp; Make Business Agile
                        </p>
                    </div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide
            ><div class="banner-item">
                <div
                    class="banner-img"
                    :style="{ backgroundImage: 'url(' + imgUrl2 + ')' }"
                ></div>
                <div class="banner-cont">
                    <div class="text-box">
                        <p class="title">
                            OCEANBLUE CLOUD
                        </p>
                        <!-- <p class="cont">
                            如今的网络混杂且复杂。应用分散又动态多变。用户不仅异地还需要移动办公。在异常复杂的IT环境中，您需要最大程度地提升性能和可见性。Riverbed可助您一臂之力。
                        </p> -->
                    </div>
                </div>
            </div>
        </swiper-slide>

        <div
            class="swiper-pagination swiper-pagination-white"
            slot="pagination"
        ></div>
        <div
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
        ></div>
        <div
            class="swiper-button-next swiper-button-white"
            slot="button-next"
        ></div>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";

import "swiper/css/swiper.css";
export default {
    name: "Banner",
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                loop: false,
                slidesPerView: "auto",
            },
            imgUrl: require("@/assets/images/banner/banner_1.jpg"),
            imgUrl1: require("@/assets/images/banner/banner_2.jpg"),
            imgUrl2: require("@/assets/images/banner/banner_3.jpg"),
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        },
    },
    mounted() {
        // console.log("Current Swiper instance object", this.swiper);
        // this.swiper.slideTo(3, 1000, false);
    },
};
</script>

<style scoped>
.banner-item {
    position: relative;
}
.banner-item > img {
    width: 100%;
    height: 556px;
}
.banner-cont {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.text-box {
    width: 1200px;
    margin: 0 auto;
    cursor: default;
}
.title {
    font-size: 48px;
    font-weight: bold;
    color: #fff;
    width: 684px;
    line-height: 62px;
}
.cont {
    font-size: 24px;
    /* width: 653px; */
    margin-top: 45px;
    color: #fff;
    line-height: 40px;
    font-weight: bold;
}
.banner-img {
    height: 556px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #00a3d1;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Home/Banner.vue